import { render } from "./manage-ticket.component.vue?vue&type=template&id=2706a704&scoped=true"
import script from "./manage-ticket.component.vue?vue&type=script&lang=js"
export * from "./manage-ticket.component.vue?vue&type=script&lang=js"

import "./manage-ticket.component.vue?vue&type=style&index=0&id=2706a704&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2706a704"]])

export default __exports__